import { render, staticRenderFns } from "./dom.vue?vue&type=template&id=a4fbb49e&"
import script from "./dom.vue?vue&type=script&lang=js&"
export * from "./dom.vue?vue&type=script&lang=js&"
import style0 from "./dom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dom.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./dom.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports